<!-- <div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center">
        <img src="logo.png" alt="Image" height="50" class="mb-3" />
        <div style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, #9194ff 0%, #f47f46 100%);">
            <div class="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center" style="border-radius:53px">
                <span class="text-blue-500 font-bold text-3xl">Sin servicio</span>
                <h1 class="text-900 font-bold text-3xl lg:text-5xl mb-2">Ventana de mantenimiento</h1>
                <div class="text-600 mb-5">Por el momento no se puede realizar ninguna operación, favor de intentarlo más tarde</div>
            </div>
        </div>
    </div>
</div> -->
<router-outlet></router-outlet>